import { render, staticRenderFns } from "./wallet-cash-transfer.vue?vue&type=template&id=78db6ca2"
import script from "./wallet-cash-transfer.vue?vue&type=script&lang=js"
export * from "./wallet-cash-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports